module.exports = __webpack_public_path__ + "img/contact-status.ef3c5f36.svg";